import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./index.css";
import withTranslation from "@src/template/components/translation";
import button from "@src/template/styles/button.css";

class CookieDisclaimer extends Component {
  constructor(props) {
    super(props);
    this.acceptBtnHandler = this.acceptBtnHandler.bind(this);
  }

  acceptBtnHandler() {
    const cookie = localStorage.getItem("cookie_policy");
    let cookiePolicy = JSON.parse(cookie);
    if (!cookiePolicy) {
      cookiePolicy = [];
    }
    if (cookiePolicy.indexOf(this.props.geoCountry) < 0) {
      cookiePolicy.push(this.props.geoCountry);
    }
    localStorage.setItem("cookie_policy", JSON.stringify(cookiePolicy));
    this.props.closeCookieMessage();
  }

  render() {
    const {
      formatTranslation,
      cookieMessageOpen,
      isSidePanelOpen,
      defaultStoreUrl
    } = this.props;

    const shouldDisplayCookieDisclaimer = !isSidePanelOpen && cookieMessageOpen;

    return shouldDisplayCookieDisclaimer ? (
      <div className={styles.cookieDisclaimer}>
        <div className={styles.container} data-testid="cookie-disclaimer">
          <div className={styles.content}>
            <p
              className={styles.summary}
              dangerouslySetInnerHTML={{
                __html: formatTranslation("cookiedisclaimer_summary", {
                  cookiePolicyLink: defaultStoreUrl.concat(
                    formatTranslation("cookiedisclaimer_link")
                  )
                })
              }}
            />
            <button
              type="button"
              className={styles.buttonAccept}
              onClick={this.acceptBtnHandler}
              data-testid="close-button"
              aria-label={formatTranslation("icon_close")}
            >
              {formatTranslation("cookiedisclaimer_accept")}
            </button>
          </div>
        </div>
      </div>
    ) : null;
  }
}

CookieDisclaimer.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  closeCookieMessage: PropTypes.func.isRequired,
  cookieMessageOpen: PropTypes.bool.isRequired,
  isSidePanelOpen: PropTypes.bool.isRequired,
  defaultStoreUrl: PropTypes.string.isRequired,
  geoCountry: PropTypes.string
};

export default withTranslation(CookieDisclaimer);
